import React from 'react';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';

interface IGoBackButtonProps {
  title: string;
  onClick(): void;
}

const GoBackButtonFacelift: React.FC<IGoBackButtonProps> = ({
  title,
  onClick
}) => {
  return (
    <Button
      name="goBackButton"
      onClick={onClick}
      icon={<Icon option="ArrowLeft" />}
      variant="tertiary"
    >
      {title}
    </Button>
  );
};

export default GoBackButtonFacelift;
